import { render, staticRenderFns } from "./ConsentimentoCookies.vue?vue&type=template&id=3fa60cc9&scoped=true"
import script from "./ConsentimentoCookies.vue?vue&type=script&lang=js"
export * from "./ConsentimentoCookies.vue?vue&type=script&lang=js"
import style0 from "./ConsentimentoCookies.vue?vue&type=style&index=0&id=3fa60cc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa60cc9",
  null
  
)

export default component.exports